import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import * as React from "react";

import { useLoc } from "../../../hooks/useLoc";
import getLocationPath from "../../../services/getLocationPath";
import { CountryBase } from "../../../templates/fragments/country";
import { RegionStub } from "../../../templates/fragments/region";

export const DesktopFooter = ({
    bestCountries,
    bestRegions
}: {
    bestCountries: CountryBase[];
    bestRegions: RegionStub[];
}) => {
    const loc = useLoc();

    return (
        <>
            <hr className="mt-20 w-full"></hr>
            <div className="m-auto flex w-full items-start px-[10%] py-10 text-xs text-zinc-500 lg:text-sm">
                <SectionItem
                    text={loc("footer.aboutSunheron.title")}
                    singleCol={true}
                >
                    <LinkItem
                        to={"/about-us/"}
                        text={loc("footer.aboutSunheron.aboutUs")}
                    ></LinkItem>
                    <LinkItem
                        to={"/privacy-policy/"}
                        text={loc("footer.aboutSunheron.privacyPolicy")}
                    ></LinkItem>
                    <LinkItem
                        to={"/cookie-policy/"}
                        text={loc("footer.aboutSunheron.cookiePolicy")}
                    ></LinkItem>
                    <LinkItem to={"/faq/"} text={"FAQ"}></LinkItem>
                    <LinkItem
                        to={"/contact/"}
                        text={loc("footer.aboutSunheron.contact")}
                    ></LinkItem>
                </SectionItem>
                <SectionItem
                    text={loc("footer.topCountries")}
                    singleCol={false}
                >
                    {bestCountries.slice(0, 10).map((country) => (
                        <LinkItem
                            key={country.slug}
                            to={getLocationPath({
                                location: country,
                                isCountryInstance: true,
                                monthIndex: 12
                            })}
                            text={country.name}
                        ></LinkItem>
                    ))}
                </SectionItem>
                <SectionItem
                    text={loc("footer.topDestinations")}
                    singleCol={false}
                >
                    {bestRegions.slice(0, 10).map((region) => (
                        <LinkItem
                            key={region.slug}
                            to={getLocationPath({
                                location: region,
                                isCountryInstance: false,
                                monthIndex: 12
                            })}
                            text={region.name}
                        ></LinkItem>
                    ))}
                </SectionItem>
            </div>
            <hr className="mx-[10%] mb-10"></hr>
            <div className="flex w-full px-[10%] pb-10 text-sm text-zinc-500 opacity-80">
                <div className="flex-1">
                    <OutboundLink
                        href="https://www.facebook.com/sunheronweather"
                        target="_blank"
                    >
                        <span className="mr-4">Facebook</span>
                    </OutboundLink>
                    <OutboundLink
                        href="https://www.instagram.com/sunheron/"
                        target="_blank"
                    >
                        <span className="">Instagram</span>
                    </OutboundLink>
                </div>
                <p className="flex-1 text-center">
                    {loc("footer.reservedRights")}
                </p>
                <div className="flex-1"></div>
            </div>
        </>
    );
};

const LinkItem = ({ to, text }) => {
    return (
        <div>
            <Link to={to}>{text} </Link>
        </div>
    );
};

const SectionItem = ({ children, singleCol, text }) => {
    return (
        <div className="flex-1">
            <div className="mb-12 text-base font-bold text-zinc-800 lg:text-lg">
                {text}
            </div>
            <div
                className={`grid grid-flow-col grid-rows-[repeat(5,auto)] gap-y-7 gap-x-3 opacity-60 ${
                    singleCol ? "grid-cols-1" : "grid-cols-2"
                }`}
            >
                {children}
            </div>
        </div>
    );
};
